import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react'
import ReactDOM from 'react-dom'

import ReactGA from 'react-ga'

// Note the polyfills at the top. These are REQUIRED to support older browsers!

// Redux
import { Provider } from 'react-redux'

import * as serviceWorker from './serviceWorker'

// Add roboto font
import 'typeface-roboto';

// Add Material design icons
import '@mdi/font/css/materialdesignicons.min.css';
// Add bootstrap
import 'bootstrap/dist/css/bootstrap.css';

// Custom styles
import './css/styles.css';

// Redux store
import { store } from './store'

import * as settings from './globals/settings'

// Main component
import App from './app'

ReactGA.initialize(settings.GA_TOKEN);

const rootApp = (
    <App />
);

ReactDOM.render(rootApp, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
